import { useActions } from '@/store/useStore';
import eventbus from 'tiny-emitter/instance';
import { App, createApp, h } from 'vue';
import Application from '../application';
import PathSection from '../models/sections/path';
import DrawPathTool from './DrawPathTool.vue';
import EditPathTool from './EditPathTool.vue';

type ToolOptions = {
  smoothing?: boolean;
};

export const createPathTool = (app: Application, options: ToolOptions = {}) => {
  const toolSpace = app.svg.group();

  let vueApp: App<Element>;
  const promise = new Promise<{ d: string; bbox: DOMRect }>((resolve) => {
    const onFinish = (data: { d: string; bbox: DOMRect }) => {
      vueApp.unmount();
      toolSpace.remove();
      resolve(data);
    };
    vueApp = createApp({
      setup: () => () => h(DrawPathTool, { onFinish }),
    });
    vueApp.mount(toolSpace.node);
  });

  const cancel = () => {
    vueApp.unmount();
    toolSpace.remove();
    useActions('seatmap').setResizedUnit(null);
  };

  return { promise, cancel };
};

const { enableSelection } = useActions('settings');

export const createPathEditTool = (app: Application, section: PathSection) => {
  const toolSpace = app.svg.group();

  const finish = () => {
    vueApp.unmount();
    toolSpace.remove();
    enableSelection();
    app.seatmap.selection.add(section);
    eventbus.emit('selection:updated', app.seatmap.selection);
    useActions('seatmap').setResizedUnit(null);
  };

  const cancel = () => {
    vueApp.unmount();
    toolSpace.remove();
    section.restoreBackup();
    enableSelection();
    app.seatmap.selection.add(section);
    eventbus.emit('selection:updated', app.seatmap.selection);
    useActions('seatmap').setResizedUnit(null);
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      finish();
    }

    if (event.key === 'Escape') {
      cancel();
    }
  };

  const vueApp = createApp({
    setup: () => () => h(EditPathTool, { section, onKeyDown }),
  });
  vueApp.mount(toolSpace.node);

  return { finish, cancel };
};
